import { useFormContext } from "../hooks/form-context";
import type { ButtonProps } from "@mantine/core";
import { Button as AppButton } from "@/components/common/Button/Button";

interface SubscribeButtonProps extends ButtonProps {
  label: string;
}

function SubscribeButton({ label, ...props }: SubscribeButtonProps) {
  const form = useFormContext();
  return (
    <form.Subscribe selector={(state) => ({
      canSubmit: state.canSubmit,
      isSubmitting: state.isSubmitting,
      isPristine: state.isPristine,
      errorMap: state.errorMap,
    })}>
      {({ canSubmit, isSubmitting, isPristine, errorMap }) => {
        // Check for any form-level errors in errorMap (onChange, onMount, onBlur, etc.)
        const hasFormErrors = Object.values(errorMap).some(
          (error) => error !== undefined && error !== null && error !== ''
        );
        
        // Button should be disabled if:
        // 1. canSubmit is false (field-level issues)
        // 2. Form is currently submitting
        // 3. Form is pristine (user hasn't interacted yet)
        // 4. There are form-level validation errors
        const isDisabled = !canSubmit || isSubmitting || isPristine || hasFormErrors;
        
        return (
          <AppButton type="submit" {...props} disabled={isDisabled}>
            {label}
          </AppButton>
        );
      }}
    </form.Subscribe>
  );
}

export default SubscribeButton;
